import React from 'react';
import { BsArrowRight } from 'react-icons/bs';
import { FcApproval, FcAssistant, FcBusinessman, FcPlus } from 'react-icons/fc';
import { MdError } from 'react-icons/md';
import { RiRefreshLine } from 'react-icons/ri';
import { Button, Col, Form, Label, Row } from 'reactstrap';
import UserAccountNav from '../../components/Header/UserAccountNav';
import {
  EmptyResult,
  ModalLoader,
  PaginationButtons
} from '../../components/misc.js';
import Enums from "../../constants/enums";
import AccountContext from "../../contexts/AccountContext";
import ActionContext from "../../contexts/ActionContext";
import ModalContext from "../../contexts/ModalContext";
import { getEntry, NetworkErrorHandler } from '../../utils/dataGenerator';

const { BroadcastChannel } = require('broadcast-channel');
const channel = new BroadcastChannel(Enums?.BROADCAST_CHANNELS?.ACCOUNTS);

const mql = window.matchMedia(`(min-width: 800px)`);
const _ = require('lodash');

const AdminDashboard = props => {
  const accountContext = React.useContext(AccountContext);
  const actionContext = React.useContext(ActionContext);
  const modalContext = React.useContext(ModalContext);
  const [sidebarDocked, setSidebarDocked] = React.useState(true);
  const [accounts, setAccounts] = React.useState([]);
  const [user, setUser] = React.useState(null);
  const [searchTerm, setSearchTerm] = React.useState('');
  const [pagination, setPagination] = React.useState({
    page: 1,
    limit: 10,
    totalDocs: 0
  });
  const [state, setState] = React.useState({
    isFetching: true,
  });

  const mediaQueryChanged = () => {
    setSidebarDocked(mql.matches);
  };

  React.useEffect(() => {
    mql.addListener(mediaQueryChanged);
    accountContext.getUser(user => {
      if (!user) {
        setTimeout(() => {
          (window.location = '/');
        }, 3000);
      } else {
        setUser(user);
      }
    });
  }, []);

  React.useEffect(() => {
    getUserAccounts();
  }, [pagination.page, pagination.limit]);

  const onSearch = (e) => {
    if (e) e.preventDefault();
    if (pagination.page !== 1) {
      setPagination({ ...pagination, page: 1 });
    } else {
      getUserAccounts();
    }
  };

  const onReset = () => {
    setSearchTerm('');
    if (pagination.page !== 1) {
      setPagination({ ...pagination, page: 1 });
    } else {
      getUserAccounts();
    }
  };

  React.useEffect(() => {
    channel.onmessage = res => {
      try {
        getUserAccounts();
      } catch (error) {
        console.error(error);
      }
    };
  }, []);

  const getUserAccounts = () => {
    setState({ ...state, isFetching: true });
    let url = `users?$page=${pagination.page}&$limit=${pagination.limit}`;
    if (searchTerm) url += `&$search=${searchTerm}`;

    getEntry(url, (res, err) => {
      setState({ ...state, isFetching: false });
      if (!err) {
        const response = res.data;
        setAccounts(response.users);
        setPagination({
          ...pagination,
          totalDocs: response.totalDocs,
          page: response.page,
          limit: response.limit
        });
      } else {
        actionContext.showNotification(
          <div className="align-center">
            <MdError style={{ fontSize: 20, color: 'red' }} />
            &nbsp;{NetworkErrorHandler(err)}
          </div>,
          { type: 'error' },
        );
      }
    });
  };

  return (
    <>
      <UserAccountNav current="dashboard" sidebarDocked={sidebarDocked}>
        {state.isFetching ? (
          <ModalLoader open={state.isFetching} />
        ) : (
          <div className="mt-0">
            <div
              style={{
                minHeight: '100vh',
                paddingTop: sidebarDocked ? 50 : 100,
              }}
            >
              <div className="p-3 p-md-4">
                <Row>
                  <Col md={8}>
                    <h4 className="orange-text title-text">Dashboard</h4>
                  </Col>
                  <Col md={4} className="align-right">
                    <Button
                      color="dark"
                      className="clickable --with-highlight"
                      onClick={() => modalContext.toggleAccSideBar()}
                    >
                      <FcPlus style={{ fontSize: 20 }} />
                      &nbsp;Add Account
                    </Button>
                  </Col>
                </Row>
              </div>
              <div className="p-3 p-md-4">
                <Row className="mb-4">
                  <Col md={12}>
                    <Form onSubmit={onSearch} className="d-flex">
                      <div className="flex-grow-1 mr-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search by name, account number, or email..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>
                      <Button color="dark" className="bg-orange border-0 mr-2">
                        Search
                      </Button>
                      <Button
                        type="button"
                        color="secondary"
                        onClick={onReset}
                      >
                        Reset
                      </Button>
                    </Form>
                  </Col>
                </Row>
                <Row>
                  {_.isEmpty(accounts) ? (
                    <Col xs={12}>
                      <EmptyResult text="No accounts found matching your search." />
                    </Col>
                  ) : (
                    _.map(accounts, function (user, index) {
                      return (
                        <Col
                          md={3}
                          sm={6}
                          key={index}
                          className={`shadow admin-card bg-grey p-0 clickable mt-4 mb-2 mx-4 overflow-hidden`}
                        >
                          <Row>
                            <Col xs={3} className="aligner-container p-2">
                              <div className="thumbnail-xs mx-auto aligner-container shadow-lg">
                                <span className="white-text">
                                  {user.first_name.substr(0, 1)}
                                </span>
                              </div>
                            </Col>
                            <Col xs={9} className="p-2 overflow-hidden">
                              <Form>
                                <Label className="stretched-text-xs">Name</Label>
                                <p className="stretched-text-xs capitalize my-0 text-truncate" title={`${user.first_name} ${user.last_name}`}>{`${user.first_name} ${user.last_name}`}</p>
                                <Label className="stretched-text-xs">Username</Label>
                                <p className="stretched-text-xs my-0">
                                  {user.username}&nbsp;
                                  {user.type == Enums.ACCOUNT_TYPES.ROOT ? (
                                    <FcApproval
                                      style={{ fontSize: 20 }}
                                      title="Root"
                                    />
                                  ) : user.type == Enums.ACCOUNT_TYPES.AO ? (
                                    <FcAssistant
                                      style={{ fontSize: 20 }}
                                      title="Account Officer"
                                    />
                                  ) : (
                                    <FcBusinessman
                                      style={{ fontSize: 20 }}
                                      title="Account Holder"
                                    />
                                  )}
                                </p>
                              </Form>
                            </Col>
                          </Row>
                          <div
                            className="bg-dark py-2 px-3 align-right clickable --with-highlight"
                            onClick={() => modalContext.openAccount(user)}
                          >
                            <span
                              className="white-text stretched-text-xs"
                              style={{ fontSize: 13 }}
                            >
                              More Info&nbsp;
                              <BsArrowRight
                                className="white-text"
                                style={{ fontSize: 20 }}
                              />
                            </span>
                          </div>
                        </Col>
                      );
                    })
                  )}
                </Row>
                {!_.isEmpty(accounts) && (
                  <PaginationButtons
                    pagination={pagination}
                    onPageChange={page => setPagination({ ...pagination, page })}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </UserAccountNav>
    </>
  );
};

export default AdminDashboard;
